import { render, staticRenderFns } from "./confirmDeletionFirebaseModal.vue?vue&type=template&id=d128d732&"
import script from "./confirmDeletionFirebaseModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionFirebaseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports